import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette } from '../theme';

const useTextStyles = makeStyles((theme: Theme) => {
  return createStyles({
    h1: {
      fontSize: 32,
      lineHeight: '38px',
      color: colorsPalette.white,
      fontWeight: 'bold',
      marginBottom: 0,
      [theme.breakpoints.up('md')]: {
        fontSize: 40,
        lineHeight: '48px',
      },
    },
    h2: {
      fontSize: 24,
      lineHeight: '28px',
      color: colorsPalette.white,
      fontWeight: 'bold',
      marginBottom: 0,
      [theme.breakpoints.up('md')]: {
        fontSize: 28,
        lineHeight: '34px',
      },
    },
    h3: {
      fontSize: 18,
      lineHeight: '22px',
      color: colorsPalette.white,
      fontWeight: 'bold',
      marginBottom: 0,
      [theme.breakpoints.up('md')]: {
        fontSize: 20,
        lineHeight: '24px',
      },
    },
    h4: {
      fontWeight: 'bold',
      color: colorsPalette.white,
      fontSize: 18,
      lineHeight: '22px',
      margin: 0,
    },
    body: {
      fontSize: 16,
      lineHeight: '26px',
      [theme.breakpoints.up('md')]: {
        fontSize: 18,
      },
    },
    bodyIntro: {
      fontSize: 18,
      lineHeight: '24px',
      [theme.breakpoints.up('md')]: {
        fontSize: 20,
        lineHeight: '30px',
      },
    },
    button2: {
      fontSize: 16,
      lineHeight: 1,
      color: colorsPalette.white,
      fontWeight: 'bold',
      [theme.breakpoints.up('md')]: {
        fontSize: 18,
      },
    },
    meta: {
      fontSize: 14,
      lineHeight: '18px',
    },
  });
});

export default useTextStyles;
